module.exports = __webpack_public_path__ + "img/people-leader.28d959ba.svg";